import { isAndroid, isIOS, isMacOs, isWindows } from "react-device-detect";

import {
  APP_STORE_URL,
  DOWNLOAD_PAGE_URL,
  MAC_DOWNLOAD_URL,
  PLAY_STORE_URL,
  WINDOWS_DOWNLOAD_URL,
} from "./links";

/**
 * The download that makes sense for the visitor's platform (the header button
 * and the "Get the app" link use this, the way t.me offers "Download for Mac").
 * @returns {{ label: string, href: string }}
 */
export function getDownloadTarget() {
  if (isIOS) return { label: "Download for iPhone", href: APP_STORE_URL };
  if (isAndroid) return { label: "Get it on Google Play", href: PLAY_STORE_URL };
  if (isMacOs) return { label: "Download for Mac", href: MAC_DOWNLOAD_URL };
  if (isWindows) return { label: "Download for Windows", href: WINDOWS_DOWNLOAD_URL };
  return { label: "Get the app", href: DOWNLOAD_PAGE_URL };
}
